module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable45.d01d80d8.jpg";